import { Outlet, Navigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';
import { AdminDashboardLayout } from './AdminDashboardLayout';

export default function AdminLayout() {
  // Check authentication and admin permissions
  const token = localStorage.getItem('authToken');
  
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  // Decode token to check permissions
  let userData;
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    userData = JSON.parse(jsonPayload);
    
    // Check if token is expired
    if (userData.exp && userData.exp * 1000 < Date.now()) {
      localStorage.clear();
      return <Navigate to="/admin/login" replace />;
    }
  } catch {
    localStorage.clear();
    return <Navigate to="/admin/login" replace />;
  }

  // Check admin permissions
  if (!userData.permissions || !userData.permissions.includes('admin:manage')) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Card>
          <CardContent className="p-8 text-center">
            <Shield className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              ไม่มีสิทธิ์เข้าถึง
            </h2>
            <p className="text-gray-600 mb-4">
              คุณไม่มีสิทธิ์เข้าถึงระบบ Admin
            </p>
            <Button onClick={() => {
              localStorage.clear();
              window.location.href = '/admin/login';
            }}>
              กลับไปหน้าเข้าสู่ระบบ
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <AdminDashboardLayout>
      <Outlet />
    </AdminDashboardLayout>
  );
}